import * as Sentry from '@sentry/react';

export const catchExceptions = Sentry.captureException;
